import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: "gfu-project-mini-wizard__collapse",
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleCollapsed && $options.toggleCollapsed(...args))),
    "data-qa": "mini-wizard-button:ShowHide"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
            'gfu-project-mini-wizard__collapse-icon',
            { 'gfu-project-mini-wizard__collapse-icon--expanded': !$props.isCollapsed }
        ])
    }, null, 2 /* CLASS */),
    ($props.isCollapsed)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCollapsibleShowItemsButton), 1 /* TEXT */))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCollapsibleHideItemsButton), 1 /* TEXT */))
  ]))
}